import { render, staticRenderFns } from "./newWebPeriodMonitoring.vue?vue&type=template&id=507fa9e7&scoped=true"
import script from "./newWebPeriodMonitoring.vue?vue&type=script&lang=js"
export * from "./newWebPeriodMonitoring.vue?vue&type=script&lang=js"
import style0 from "./newWebPeriodMonitoring.vue?vue&type=style&index=0&id=507fa9e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507fa9e7",
  null
  
)

export default component.exports